import React from 'react';

import { makeStyles } from '@material-ui/core/styles';

import { Icon } from '@hydra/common/components';
import FilterChip from '@hydra/common/components/ReviewFilter/FilterChip';
import FilterSelect from '@hydra/common/components/ReviewFilter/FilterSelect';

const useStyles = makeStyles(theme => ({
  root: { display: 'flex' },
  icon: {
    display: 'flex',
    alignItems: 'center',
    marginRight: theme.spacing(2)
  },
  filter: {
    marginRight: theme.spacing(1),
    [theme.breakpoints.down('xs')]: {
      margin: theme.spacing(0.5)
    }
  },
  filterContainer: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap'
  },
  selectContainer: { display: 'flex' }
}));

export const ReviewFilter = ({ filters, handleFilter, handleSelect }) => {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <div className={classes.icon}>
        <Icon type='filter' size='md' />
      </div>
      <div className={classes.filterContainer}>
        <div className={classes.filter}>
          <FilterChip value='good' active={filters.good} handleFilter={handleFilter} />
        </div>
        <div className={classes.filter}>
          <FilterChip value='average' active={filters.average} handleFilter={handleFilter} />
        </div>
        <div className={classes.filter}>
          <FilterChip value='bad' active={filters.bad} handleFilter={handleFilter} />
        </div>
        <div className={classes.filter}>
          <FilterChip value='none' active={filters.neutral} handleFilter={handleFilter} />
        </div>
        <div className={classes.selectContainer}>
          <div className={classes.filter}>
            <FilterSelect
              icon='impact'
              content='impact'
              filterType='importance'
              items={{
                lowImpact: filters.lowImpact,
                mediumImpact: filters.mediumImpact,
                highImpact: filters.highImpact
              }}
              handleSelect={handleSelect}
            />
          </div>
          <div className={classes.filter}>
            <FilterSelect
              icon='gear'
              content='effort'
              filterType='solvability'
              items={{
                easyEffort: filters.easyEffort,
                hardEffort: filters.hardEffort,
                veryHardEffort: filters.veryHardEffort
              }}
              handleSelect={handleSelect}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default React.memo(ReviewFilter);
